var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "not-paid-User": _vm.isTrialExpired } },
    [
      _c("div", {
        ref: "streetView",
        staticClass: "street-view",
        style: { zIndex: _vm.isStreetView ? "3" : "-1" },
      }),
      _vm.isStreetView
        ? _c(
            "div",
            { staticClass: "close-button" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-white md-icon-button",
                  attrs: { "md-ripple": false },
                  on: {
                    click: function ($event) {
                      return _vm.$_map_closeStreetView(false)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "md-card",
        [
          _c(
            "md-card-header",
            { staticClass: "md-card-header-icon md-card-header-warning" },
            [
              _c(
                "div",
                { staticClass: "card-icon" },
                [_c("md-icon", [_vm._v("map")])],
                1
              ),
            ]
          ),
          _c(
            "md-card-content",
            [
              _c("div", { ref: "map", staticClass: "map" }),
              _vm.showInfoWindow
                ? _c(
                    "md-content",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.closeInfoWindow,
                          expression: "closeInfoWindow",
                        },
                      ],
                      staticClass: "info-tooltip md-elevation-2 md-layout",
                      style: _vm.infoWindowStyles,
                    },
                    [
                      _c("md-content", { staticClass: "button--actions" }),
                      _vm.content.isShipmentStatus
                        ? _c(
                            "md-content",
                            {
                              staticClass:
                                "info-detail--container shipment-status--detail",
                            },
                            [
                              _c("md-icon", [_vm._v("contacts")]),
                              _c("md-content", { staticClass: "info-detail" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Changed By"),
                                ]),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.content.changedBy)),
                                ]),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.content.isShipmentStatus
                        ? _c(
                            "md-content",
                            {
                              staticClass:
                                "info-detail--container shipment-status--detail",
                            },
                            [
                              _c("md-icon", [_vm._v("date_range")]),
                              _c("md-content", { staticClass: "info-detail" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Location Change"),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("dateTimeFormat")(
                                        _vm.content.actionDate
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.content.isShipmentStatus
                        ? _c(
                            "md-content",
                            {
                              staticClass:
                                "info-detail--container shipment-status--detail shipment-status--change",
                            },
                            [
                              _c(
                                "span",
                                {
                                  style: {
                                    color: _vm.setColor(_vm.content.oldStatus),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.content.oldStatus) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                              _c("md-icon", { staticClass: "arrow-icon" }, [
                                _vm._v("arrow_right_alt"),
                              ]),
                              _c(
                                "span",
                                {
                                  style: {
                                    color: _vm.setColor(_vm.content.newStatus),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.content.newStatus) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.content.isShipment
                        ? _c(
                            "md-content",
                            { staticClass: "info-detail--container" },
                            [
                              _c("md-icon", [_vm._v("location_on")]),
                              _c(
                                "md-content",
                                { staticClass: "info-detail shipment-detail" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("Address"),
                                  ]),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.content.address)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }